import {Multilingual} from '../types/state'

const defaultState: Multilingual = {
  isEnabled: false,
  currentLanguage: null,
  isPrimaryLanguage: true,
}

export const multilingual = (state = defaultState) => {
  return state
}
